import 'css-chunksrc/client/scenes/assignToTask/projectSelection/search/styles.scss';export default {
  "search": "_search_pco3i_1"
};